
<div class="container">
    <!-- Top Bar -->
    <div class="top-bar">
        <!-- Back Button with arrow-left icon -->
        <button kendoButton class="btn btn--small btn--outline" (click)="onBack()" [fillMode]="'flat'" [svgIcon]="arrowLeftIcon">
            Details
        </button>
        <h2 class="subscription-label">{{ subscription.Label || 'No Label' }}</h2>
    </div>
    <app-price-table 
        [subscriptionID]="subscriptionID"
    ></app-price-table>

    <!-- Dialog for Subscription Change Confirmation -->
@if (showSubscriptionChangeDialog) {
    <div class="modal-backdrop">
      <div class="modal-dialog">
        <h2 class="dialog-title">Confirm Your Updates</h2>
        <p class="dialog-subtitle">Review the changes to your subscription before confirming.</p>
  
        @if (!isSaving) {
          <!-- Subscription Update Preview -->
          <app-subscription-update-preview
            [subscription]="subscription"
            [options]="previewOptions"
            (previewLoaded)="onPreviewLoaded($event)"
          >
          </app-subscription-update-preview>

          <!-- Dialog Actions (Buttons) -->
          <div class="dialog-actions">
            <button kendoButton [disabled]="!isPreviewLoaded" themeColor="primary"
                    (click)="confirmSubscriptionChange()">
              Confirm
            </button>
            <button kendoButton (click)="closeSubscriptionChangeDialog()">
              Cancel
            </button>
          </div>
        } 
        @else {
          <!-- Loading Spinner while saving -->
          <div class="loading-spinner">
            <ng-lottie options="/assets/animations/loading1.json" width="250px" height="250px"></ng-lottie>
            <p>{{ savingMessage }}</p>
          </div>
        }
      </div>
    </div>
  }
</div>
